<template>
  <section class="entry-multi-tab">
    <main class="entry-multi-tab__wrapper">
      <a-tabs
        hideAdd
        type="editable-card"
        :activeKey="activeKey"
        @change="onChange"
        @edit="onEdit"
      >
        <a-tab-pane
          v-for="(pane,index) in panes"
          :key="pane.key"
          :closable="pane.closable"
        >
          <a-icon v-if="index === 0" slot="tab" type="home" />
          <span v-else slot="tab">{{ pane | menuNameRender }}</span>
        </a-tab-pane>
        <div slot="tabBarExtraContent">
          <!-- 易学堂（直播/回放） -->
          <div class="entry-oguide" v-demo="'guideToLive'" style="border-right: 1px solid #E5E8EB;">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M4.69043 4.52224C4.69043 4.255 4.88015 4.14503 5.11275 4.27576L8.88836 6.39733C9.12157 6.52842 9.12096 6.74135 8.88836 6.87196L5.11275 8.99354C4.87954 9.12463 4.69043 9.0143 4.69043 8.74705V4.52224Z" fill="white" stroke="#4E535C"/>
              <circle cx="6.33789" cy="6.875" r="5.625" stroke="#4E535C"/>
            </svg>
            <span style="margin-left: 5px">{{ $t('layouts.直播/回放') }}</span>
          </div>
          <div class="entry-oguide"  v-demo="'guideTo'">
            <icon-font type="gb-icon-helper-circle" style="margin-right: 5px"/>
            <span>{{ $t('layouts.operation.guide') }}</span>
          </div>
          <a-dropdown  :trigger="['click']" >
            <div class="dropdown-content">
              <a-icon type="down" />
            </div>
            <a-menu slot="overlay" @click="closeMenuClick">
              <a-menu-item key="ClosePane">{{ $t('tabs.close.current') }}</a-menu-item>
              <a-menu-item key="CloseRightPanes">{{ $t('tabs.close.right') }}</a-menu-item>
              <a-menu-item key="CloseLeftPanes">{{ $t('tabs.close.left') }}</a-menu-item>
              <a-menu-item key="CloseAllPane">{{ $t('tabs.close.all') }}</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-tabs>
    </main>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import { documentChangeUrl } from '@/store/_util/util'

export default {
  name: 'EntryMultiTab',
  props: {
    panes: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  methods: {
    ...mapActions({
      remove: 'entry/ClosePane'
    }),
    onChange (activeKey) {
      this.$emit('change', activeKey, { statisticsType: 1 })
    },
    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    closeMenuClick ({ key }) {
      const { activeKey } = this
      // 后期需要优化，尽量减少$store直接操作
      this.$store.dispatch(`entry/${key}`, activeKey)
    },
    guideTo () {
      const { activeKey } = this
      // this.$winOpen('/#/middleware?toHelp=true&id=' + activeKey.replace(/[^0-9]+/, ''))
      documentChangeUrl(this, activeKey.replace(/[^0-9]+/, ''))
    },
    guideToLive () {
      const { serviceId, systemCode } = this.$route.params
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/live-roadcast`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.entry-multi-tab {
  background: #fff;
  z-index: 55;
  .entry-oguide {
    display: inline-block;
    // border-left: 1px solid #eee;
    padding: 0 8px;
    color: #252B3A;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      color: #077bfc
    }
  }

  .dropdown-content {
    display: inline-block;
    padding: 0 7px;
    border-left: 1px solid #eee;
    font-size: 14px;
  }

  /deep/ .@{ant-prefix}-tabs-bar {
    margin-bottom: 0!important;
  }

  /deep/ .@{ant-prefix}-tabs.@{ant-prefix}-tabs-card {
    font-size: 12px;

    .@{ant-prefix}-tabs-extra-content {
      line-height: 36px;
    }

    .@{ant-prefix}-tabs-card-bar {
      .@{ant-prefix}-tabs-nav-container {
        height: 36px;
        font-size: 12px;
      }

      .@{ant-prefix}-tabs-tab {
        margin: 0 -1px 0 0;
        border-radius: 0;
        height: 36px;
        line-height: 34px;

        &:hover {
          color: #60ABFF;
        }

        .anticon {
          margin: 0;
        }
      }
      .@{ant-prefix}-tabs-tab-active {
        color: #1890ff;
        border-bottom: 2px solid #077bfc;
      }
    }
  }
}
</style>
